import { render, staticRenderFns } from "./testscreen.vue?vue&type=template&id=620d9260&"
import script from "./testscreen.vue?vue&type=script&lang=js&"
export * from "./testscreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports